'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var BaseTracer = require('opentracing').Tracer;

var NoopTracer = require('./noop/tracer');

var DatadogTracer = require('./tracer');

var Config = require('./config');

var Instrumenter = require('./instrumenter');

var platform = require('./platform');

var log = require('./log');

var setStartupLogInstrumenter = platform.startupLog.setStartupLogInstrumenter;

var analyticsSampler = require('./analytics_sampler');

var noop = new NoopTracer();

var Tracer =
/*#__PURE__*/
function (_BaseTracer) {
  _inherits(Tracer, _BaseTracer);

  function Tracer() {
    var _this;

    _classCallCheck(this, Tracer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tracer).call(this));
    _this._tracer = noop;
    _this._instrumenter = new Instrumenter(_assertThisInitialized(_this));

    _this._deprecate = function (method) {
      return log.deprecate("tracer.".concat(method), ["tracer.".concat(method, "() is deprecated."), 'Please use tracer.startSpan() and tracer.scope() instead.', 'See: https://datadog.github.io/dd-trace-js/#manual-instrumentation.'].join(' '));
    };

    return _this;
  }

  _createClass(Tracer, [{
    key: "init",
    value: function init(options) {
      if (this._tracer === noop) {
        try {
          var config = new Config(options);
          log.use(config.logger);
          log.toggle(config.debug, config.logLevel, this);
          platform.configure(config);
          platform.profiler().start();

          if (config.enabled) {
            platform.validate();

            if (config.runtimeMetrics) {
              platform.metrics().start();
            }

            if (config.analytics) {
              analyticsSampler.enable();
            }

            this._tracer = new DatadogTracer(config);

            this._instrumenter.enable(config);

            setStartupLogInstrumenter(this._instrumenter);
          }
        } catch (e) {
          log.error(e);
        }
      }

      return this;
    }
  }, {
    key: "use",
    value: function use() {
      this._instrumenter.use.apply(this._instrumenter, arguments);

      return this;
    }
  }, {
    key: "trace",
    value: function trace(name, options, fn) {
      if (!fn) {
        fn = options;
        options = {};
      }

      if (typeof fn !== 'function') return;
      options = options || {};
      return this._tracer.trace(name, options, fn);
    }
  }, {
    key: "wrap",
    value: function wrap(name, options, fn) {
      if (!fn) {
        fn = options;
        options = {};
      }

      if (typeof fn !== 'function') return fn;
      options = options || {};
      return this._tracer.wrap(name, options, fn);
    }
  }, {
    key: "startSpan",
    value: function startSpan() {
      return this._tracer.startSpan.apply(this._tracer, arguments);
    }
  }, {
    key: "inject",
    value: function inject() {
      return this._tracer.inject.apply(this._tracer, arguments);
    }
  }, {
    key: "extract",
    value: function extract() {
      return this._tracer.extract.apply(this._tracer, arguments);
    }
  }, {
    key: "scopeManager",
    value: function scopeManager() {
      this._deprecate('scopeManager');

      return this._tracer.scopeManager.apply(this._tracer, arguments);
    }
  }, {
    key: "scope",
    value: function scope() {
      return this._tracer.scope.apply(this._tracer, arguments);
    }
  }, {
    key: "currentSpan",
    value: function currentSpan() {
      this._deprecate('currentSpan');

      return this._tracer.currentSpan.apply(this._tracer, arguments);
    }
  }, {
    key: "bind",
    value: function bind(callback) {
      this._deprecate('bind');

      return callback;
    }
  }, {
    key: "bindEmitter",
    value: function bindEmitter() {
      this._deprecate('bindEmitter');
    }
  }, {
    key: "getRumData",
    value: function getRumData() {
      if (!this._tracer._config.experimental.enableGetRumData) {
        return '';
      }

      var span = this.scope().active().context();
      var traceId = span._traceId;
      var traceTime = Date.now();
      return "<meta name=\"dd-trace-id\" content=\"".concat(traceId, "\" /><meta name=\"dd-trace-time\" content=\"").concat(traceTime, "\" />");
    }
  }]);

  return Tracer;
}(BaseTracer);

module.exports = Tracer;